import { useEffect, useState } from "react";

// While the on-screen keyboard is open, returns the visible area's
// { top, height } so a full-screen `fixed inset-0` page can shrink to sit
// above the keyboard. iOS never resizes the page for the keyboard (it only
// shrinks the visual viewport), so without this the chat box and the game's
// Word Check box end up underneath it. Returns null when no keyboard is open.
export default function useKeyboardViewport() {
  const [box, setBox] = useState(null);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return undefined;
    const update = () => {
      const covered = window.innerHeight - vv.height;
      // Pinch zoom also shrinks the visual viewport; only react at 1x.
      const open = covered > 120 && Math.abs(vv.scale - 1) < 0.01;
      setBox((prev) => {
        if (!open) return null;
        const next = { top: Math.round(vv.offsetTop), height: Math.round(vv.height) };
        return prev && prev.top === next.top && prev.height === next.height ? prev : next;
      });
    };
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    update();
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, []);

  return box;
}
